import React, { useState } from "react";
import axios from "axios";
import "./Home.css";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
const HeroForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phn: "",
    procedure: "",
    dummy: "You’ve received a new query",
  });

  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const serviceId = "service_y2wiyv9";
    const templateId = "template_9pz6455";
    const userId = "gHJShnDhyA9tSUzLk";

    emailjs
      .send(serviceId, templateId, formData, userId)
      .then(
        (result) => {
          setMessage("Your request has been successfully submitted!");
          setFormData({
            name: "",
            phn: "",
            procedure: "",
          });
          toast.success("Your request has been successfully submitted!")
        },
        
        (error) => {
          setMessage("Failed to submit the form. Please try again.");
          toast.error("Failed to submit the form. Please try again.")
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };


  return (
    // <section className="feature-three">
    //   <div className="feature-three-bg" />
    <div className="hero-form-container" style={{ width: "95%" }}>
      <div className="feature-three__top">
        <div className="row">
          <div className="col-xl-12">
            <div className="feature-three__top-inner">
              <div className="book-slider">
                <div className="" style={{ width: "100%" }}>
                  <div className="row pos-center">
                    <div className="reserve-form-area">
                      <form className="book-slider" onSubmit={handleSubmit}>
                        <ul className="clearfix">
                          <li className="li-input">
                            <div className="divss">
                              <label>First Name</label>
                              <input
                                type="text"
                                name="name"
                                className="date-selector"
                                placeholder="Enter Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </li>

                          <li className="li-input">
                            <div className="divss">
                              <label>Phone Number</label>
                              <input
                                type="text"
                                name="phn"
                                className="date-selector"
                                placeholder="Phone Number"
                                value={formData.phn}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </li>

                          <li className="li-input input_list_heroo">
                            <div className="divss">
                              <label>Select Category</label>
                              <select
                                name="procedure"
                                className="date-selector select_tag_hero_form"
                                value={formData.procedure}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Category</option>
                                <option value="Rhinoplasty">Rhinoplasty</option>
                                <option value="Septoplasty">Septoplasty</option>
                                <option value="Lipoma">Lipoma</option>
                                <option value="Gynecomastia">
                                  Gynecomastia
                                </option>
                                <option value="Ophthalmology">
                                  Ophthalmology
                                </option>
                                <option value="Lasik surgery">
                                  Lasik surgery
                                </option>
                                <option value="Cataract surgery">
                                  Cataract surgery
                                </option>
                                <option value="ICL (implantable collamer lens) treatment">
                                  ICL (implantable collamer lens) treatment
                                </option>
                                <option value="Glaucoma treatment">
                                  Glaucoma treatment
                                </option>
                                <option value="Corneal surgery">
                                  Corneal surgery
                                </option>
                                <option value="Pediatrics Eye care">
                                  Pediatrics Eye care
                                </option>
                                <option value="RLE (Refractive Lense Exchange)">
                                  RLE (Refractive Lens Exchange)
                                </option>
                                <option value="Hair transplant">
                                  Hair transplant
                                </option>
                                <option value="Skin">Skin</option>
                                <option value="Face">Face</option>
                                <option value="Body">Body</option>
                                <option value="Liposuction">Liposuction</option>
                                <option value="Breast (implant)">
                                  Breast (implant)
                                </option>
                                <option value="Gynaecology">Gynaecology</option>
                              </select>
                            </div>
                          </li>

                          <li>
                            {/* <div
                              className="hero-container-appointement booking-fotm-btn"
                              style={{ marginTop: "27px" }}
                            > */}
                            <button
                              type="submit"
                              className="hero_form_button_homt"
                              // className="th-btn"
                              disabled={loading}
                              style={{ color: "#fff", background: "none" }}
                            >
                              {loading ? "Submitting..." : "Get Care Now"}
                            </button>
                            {/* </div> */}
                          </li>
                        </ul>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroForm;
